import React from 'react';
import PropTypes from 'prop-types';
import './Material.css'

export default class RadialRipple extends React.Component {

    static propTypes = {
        disabled: PropTypes.bool
    };

    static defaultProps = {
        disabled: false
    };

    constructor(props) {
        super(props);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);
        this.element = null;
        this.counter = 0;
        this.state = {
            ripples: []
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.ripples.some(ripple => !ripple.run)) {
            return;
        }
        // trigger re-flow
        this.element.scrollTop = 0;
        this.setState((prevState, props) => {
            return {ripples: prevState.ripples.map(ripple => {
                if (ripple.run) {
                    return ripple;
                }
                return {
                    run: true,
                    rippleId: ripple.rippleId
                }
            })}
        });
    }

    onMouseDown() {
        if (this.props.disabled) {
            return;
        }
        this.setState((prevState, props) => {
            let ripples = prevState.ripples.slice();
            ripples.push({
                run: false,
                rippleId: this.counter++
            });
            return {ripples: ripples};
        });
    }

    onTransitionEnd(event) {
        let rippleId = parseInt(event.currentTarget.dataset.rippleId, 10);
        this.setState(prevState => {
            let index = prevState.ripples.findIndex(ripple => ripple.rippleId === rippleId);
            let ripples = prevState.ripples.slice();
            ripples.splice(index, 1);
            return {ripples};
        });
    }

    render() {
        return (
            <div ref={(elm) => this.element = elm} onMouseDown={this.onMouseDown} className="materialRadialRippleContainer">
                {this.state.ripples.map(ripple => {
                    let classNames = 'materialRadialRipple';
                    if (ripple.run) {
                        classNames += ' run';
                    }
                    return <div key={ripple.rippleId} data-ripple-id={ripple.rippleId} className={classNames} onTransitionEnd={this.onTransitionEnd}/>;
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/material/RadialRipple.js